var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexUpFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0205 -2.70831e-06L-2.10512e-06 18L-5.25234e-06 54L31.0205 72L62 54L62 18L31.0205 -2.70831e-06Z",
    fill: "url(#paint0_linear_1_11746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_11746",
    x1: 32.0509,
    y1: 23.5,
    x2: 36.3382,
    y2: 68.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13131B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13131B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexUpFade);
export default __webpack_public_path__ + "static/media/hexUpFade.b9e173ae0e4b142f2f18d6f9c5042c7d.svg";
export { ForwardRef as ReactComponent };